import { useParams } from 'react-router-dom';
import { useDecodeJWT } from "hooks/useDecodeJWT";

export const useCompanyId = () => {
  const { id: companyIdParam } = useParams();

  const token = useDecodeJWT();
  const organizationIdFromToken = token?.organizationId;

  const isValidCompanyId = companyIdParam && companyIdParam !== 'company';

  return isValidCompanyId ? companyIdParam : organizationIdFromToken;
};
